import React from 'react';
import clsx from 'clsx';

/** One grey shape with a light sweep across it. Size it with height / width classes; `.skeleton` carries the look. */
export const Skeleton: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => (
  <div className={clsx('skeleton rounded-md', className)} aria-hidden {...rest} />
);
